export default __webpack_public_path__ + "static/media/YmirsPass.8b714678.jpg";